<h2 mat-dialog-title class="mat-title">
  <span *ngIf="!globalNotifications; else globalNotificationsHeader">{{Headers.NotificationEngine.Schedule}}</span>
  <ng-template #globalNotificationsHeader>Schedule All Notifications</ng-template>
  <span class="close-dialog" (click)="closeDialog()">&#10006;</span>
</h2>

<mat-dialog-content>
  <div *ngIf="globalNotifications" class="globalNotifications-info">
    <mat-icon>info</mat-icon>
    <span>{{Headers.NotificationEngine.GlobalInfo}}</span>
  </div>
  <p class="mat-body-strong">Delivery Frequency</p>
  <mat-radio-group color="primary" aria-label="Select an option" [(ngModel)]="selectedFrequency">
    <mat-radio-button *ngFor="let option of scheduleFrequencyOptions" [checked]="option.checked" [value]="option.value"
      (change)="globalNotifications ? isGlobalModeChangeValid(option.value) : onModeChanged(option.value)"> <span
        class="mat-radio-label">
        {{option.name}}
      </span>
    </mat-radio-button>
  </mat-radio-group>
  <br>&nbsp;
  <div *ngIf="selectedFrequency == 'Weekly'">
    <mat-form-field floatLabel="always" appearance="outline">
      <mat-label>{{Headers.NotificationEngine.Day}}</mat-label>
      <mat-select placeholder="Select" [(ngModel)]="selectedDay"
        (selectionChange)="globalNotifications ? isGlobalModeChangeValid() : onDayTimeChanged()" disableOptionCentering>
        <mat-option *ngFor="let day of dayArr" [value]="day">{{day}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div layout="row" *ngIf="selectedFrequency != 'Immediate'&& selectedFrequency!=''" class="schedule-time">
    <mat-form-field floatLabel="always" appearance="outline">
      <mat-label>{{Headers.NotificationEngine.Time}}</mat-label>
      <mat-select placeholder="Select" [(ngModel)]="selectedTime"
        (selectionChange)="globalNotifications ? isGlobalModeChangeValid() : onDayTimeChanged()" disableOptionCentering>
        <mat-option *ngFor="let time of timeArr" [value]="time">{{time}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-radio-group color="primary" [(ngModel)]="selectedAMorPM"
      (change)="globalNotifications ? isGlobalModeChangeValid() : onAMorPMChanged(selectedAMorPM)"
      *ngIf="selectedFrequency != 'Immediate'" aria-label="Select an option">
      <mat-radio-button [checked]="selectedAMorPM=='AM'" value="AM">AM</mat-radio-button>
      <mat-radio-button [checked]="selectedAMorPM=='PM'" value="PM">PM</mat-radio-button>
    </mat-radio-group>
  </div>

  <mat-checkbox color="primary" *ngIf="!globalNotifications" (change)="applyAllChange($event)"
    class="apply-checkbox" [(ngModel)]="scheduleCategoryAllEvents">
    {{Headers.NotificationEngine.ApplyCheckbox}}
  </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button color="primary" mat-stroked-button (click)="closeDialog()">Cancel</button>
  <button color="primary" [disabled]="disableSave" mat-raised-button (click)="saveSchedule()">Apply</button>
</mat-dialog-actions>